/* eslint-disable */
import { PluginContainerData } from './common';

import { HTMLData_Source } from './plugin_html.enums';

export interface HTMLData {
  /** Styling for the HTML node's container. Height property is irrelevant for HTML embeds when autoHeight is set to `true`. */
  containerData?: PluginContainerData;
  /** The URL for the HTML code for the node. */
  url: string | undefined;
  /** The HTML code for the node. */
  html: string | undefined;
  /**
   * Whether this is an AdSense element. Use `source` instead.
   *
   * @deprecated
   */
  isAdsense?: boolean;
  /** The type of HTML code. */
  source: HTMLData_Source;
  /** If container height is aligned with its content height. Defaults to `true`. */
  autoHeight?: boolean;
}

export function hTMLData_SourceFromJSON(object: any): HTMLData_Source {
  switch (object) {
    case 0:
    case 'HTML':
      return HTMLData_Source.HTML;
    case 1:
    case 'ADSENSE':
      return HTMLData_Source.ADSENSE;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return HTMLData_Source.UNRECOGNIZED;
  }
}

export function hTMLData_SourceToJSON(object: HTMLData_Source): string {
  switch (object) {
    case HTMLData_Source.HTML:
      return 'HTML';
    case HTMLData_Source.ADSENSE:
      return 'ADSENSE';
    default:
      return 'UNKNOWN';
  }
}

const baseHTMLData: object = { source: HTMLData_Source.HTML };

export const HTMLData = {
  fromJSON(object: any): HTMLData {
    const message = { ...baseHTMLData } as HTMLData;
    message.containerData =
      object.containerData !== undefined && object.containerData !== null
        ? PluginContainerData.fromJSON(object.containerData)
        : undefined;
    message.url = object.url !== undefined && object.url !== null ? String(object.url) : undefined;
    message.html =
      object.html !== undefined && object.html !== null ? String(object.html) : undefined;
    message.isAdsense =
      object.isAdsense !== undefined && object.isAdsense !== null
        ? Boolean(object.isAdsense)
        : undefined;
    message.source =
      object.source !== undefined && object.source !== null
        ? hTMLData_SourceFromJSON(object.source)
        : HTMLData_Source.HTML;
    message.autoHeight =
      object.autoHeight !== undefined && object.autoHeight !== null
        ? Boolean(object.autoHeight)
        : undefined;
    return message;
  },

  toJSON(message: HTMLData): unknown {
    const obj: any = {};
    message.containerData !== undefined &&
      (obj.containerData = message.containerData
        ? PluginContainerData.toJSON(message.containerData)
        : undefined);
    message.url !== undefined && (obj.url = message.url);
    message.html !== undefined && (obj.html = message.html);
    message.isAdsense !== undefined && (obj.isAdsense = message.isAdsense);
    message.source !== undefined && (obj.source = hTMLData_SourceToJSON(message.source));
    message.autoHeight !== undefined && (obj.autoHeight = message.autoHeight);
    return obj;
  },
};
